// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/hydroplaning-effects-and-handling.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/hydroplaning-effects-and-handling/hydroplaning-effects-and-handling.js';
import g1 from '../lessons/aeronautics/hydroplaning-effects-and-handling/hydroplaning-recognition.js';

mount([g0, g1]);
